module.exports = __webpack_public_path__ + "img/map_quincy.db00765f.png";